import { put, call, all } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
  STOCK_DICTIONARY_EDIT_TRANSLATION_FAILURE,
  STOCK_DICTIONARY_EDIT_TRANSLATION_SUCCESS
} from '../constants'

import { SuccessAction } from '../../../common/redux/toasts'


export function* editDictionaryTranslationSaga(action){
  try {
    const result = yield call(
    BFFAgent.Stock.Dictionary.editDictionaryTranslation, action.data.id, action.data.translation)
    
    yield all([
      put({type: STOCK_DICTIONARY_EDIT_TRANSLATION_SUCCESS,
      data: result}),
      put( SuccessAction({title:"¡Listo! Los términos ya están actualizados en el diccionario."})),
  ]);

  } catch (err) {
    yield put({
      type: STOCK_DICTIONARY_EDIT_TRANSLATION_FAILURE,
      data: { error: err}
    })
  }
}